<template>
  <v-container grid-list-md fluid>
    <Create :createDialog="createDialog" @created="created" @close="createDialog = false"></Create>
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ $t("pageHeader.organizations") }}</h1>
        </v-toolbar-title>
        <v-btn
          color="teal"
          dark
          small
          absolute
          bottom
          right
          fab
          @click="create"
          v-if="checkRightStatus(55)"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-title class="mt-0">
        <v-flex xs12 md4>
          <v-text-field
            v-model="search"
            append-icon="search"
            clearable
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        v-model="selected"
        :items="organizations"
        item-key="organizationID"
        :loading="loading"
        :search="search"
        :pagination.sync="pagination"
        >
        <template slot="items" slot-scope="props">
          <tr class="pointer" @click="viewOrganization(props.item)">
            <td class="text-xs-left pointer">
              {{ $moment(props.item.createDateTime).format("MM/DD/YYYY") }}
            </td>
            <td class="text-xs-left pointer small-td" v-html="$options.filters.highlight(props.item.organizationName, search.toLowerCase())">{{ props.item.organizationName }}</td>
            <td class="text-xs-left pointer" v-html="$options.filters.highlight(props.item.ownerName, search.toLowerCase())">{{ props.item.ownerName }}</td>
            <td class="text-xs-left pointer" v-html="$options.filters.highlight(props.item.primaryPhone, search.toLowerCase())">{{ props.item.primaryPhone | USPhoneNumber }}</td>
            <td class="text-xs-left pointer small-td" v-html="$options.filters.highlight(props.item.primaryEmail, search.toLowerCase())">{{ props.item.primaryEmail }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import organizationsService from "../service.js";
import { mapGetters } from "vuex";
const Create = () => import("./Create");

export default {
  name: "organization-list",
  data() {
    return {
      selected: [],
      createDialog: false,
      terminalURL: process.env.VUE_APP_TERMINALURL,
      headers: [
        {
          text: this.$t("labels.createdAt"),
          align: "left",
          sortable: true,
          value: "createDateTime"
        },
        {
          text: this.$t("labels.name"),
          value: "organizationName",
          sortable: true,
          width: "25%"
        },
        {
          text: this.$t("labels.ownerName"),
          value: "ownerName",
          sortable: true
        },
        {
          text: this.$t("labels.primary"),
          value: "primaryPhone",
          sortable: true
        },
        {
          text: this.$t("labels.email"),
          value: "primaryEmail",
          sortable: true
        }
      ],
      search: '',
      organizations: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "createDateTime",
        descending: true
      }
    };
  },
  watch: {
    search(val) {
      if (!val) this.search = ''
    }
  },
  filters: {
    highlight(words, query) {
      if (query) {
        var check = new RegExp(query.toLowerCase(), "ig");
        if (words) {
          return words.toString().replace(check, function(matchedText) {
            return '<span class="highlight">' + matchedText + "</span>";
          });
        } else {
          return words;
        }
      } else {
        return words;
      }
    },
  },
  components: {
    Create,
  },
  created() {
    this.getList();
  },
  computed: {
    ...mapGetters("global", ["checkRightStatus"])
  },
  methods: {
    created() {
      this.createDialog = false;
      this.getList();
    },
    create() {
      this.createDialog = true;
    },
    getList() {
      return organizationsService
        .getAll()
        .then(response => {
          console.log("response from org list", response);
          this.organizations = response.data;
          this.loading = false;
          return response;
        })
        .catch(err => {
          console.log("err", err);
        });
    },
    viewOrganization(data) {
      this.$router.push({
        path: `/organization/profile/${data.organizationID}`
      });
    }
  }
};
</script>
